export const APP_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV || 'development';
